'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _feiseanna = require('../../../../../feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeisFinanceController = function () {
  function FeisFinanceController(feis, $cookieStore, $location, $window, user, fStripe) {
    _classCallCheck(this, FeisFinanceController);

    this.feis = feis;
    this.user = user;
    this._ = { $cookieStore: $cookieStore, $location: $location, $window: $window, fStripe: fStripe };

    this.stripe_is_connected = feis.is_payee;

    if (this.stripe_is_connected) {
      this.getFinancialData();
    }
  }

  _createClass(FeisFinanceController, [{
    key: 'connect',
    value: function connect() {
      this._.fStripe.oauthRedirect(this.user, this.feis);
    }
  }, {
    key: 'getFinancialData',
    value: function getFinancialData() {
      //
    }
  }]);

  return FeisFinanceController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.finance', ['ngMaterial', 'ui.router', 'ifeis.feiseanna', 'ifeis.session', 'ifeis.router-history', 'ngCookies']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.finance', {
    url: '/finance',
    template: require('./tpl.html'),
    controller: FeisFinanceController,
    controllerAs: 'finance',
    resolve: {
      user: function user(fSession) {
        return fSession.user();
      }
    },
    ncyBreadcrumb: {
      label: 'Finance',
      parent: 'feiseanna.one.admin.manager'
    }
  });

  $stateProvider.state('stripe-callback', {
    url: '/stripe-callback?code&scope&state',
    onEnter: function onEnter(fStripe, $stateParams, $state, fRouterHistoryService) {
      var code = $stateParams.code,
          scope = $stateParams.scope,
          state = $stateParams.state;

      var feis = JSON.parse(state);

      fStripe.validateOauthReturn(code, feis).then(function () {
        return $state.go('feiseanna.one.admin.finance', feis, { location: 'replace' });
      }).then(function () {
        return fRouterHistoryService.save('feiseanna.one.admin.manager', feis);
      }).catch(function (err) {
        return console.log('Could not validate stripe token', err);
      });
      ;
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/finance/index.js
// module id = 545
// module chunks = 0